"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f45 = void 0;
exports.f45 = {
    "-": [
        321,
        435,
        436,
        437,
        438,
        2006,
        2092,
        2234,
        2469,
        2692,
        2731,
        4739,
        5980,
        6101,
        52,
        53,
        75,
        76,
        354,
        355,
        372,
        373,
        1673,
        1674,
        2090,
        2091,
        2093,
        2536,
        2537,
        5703,
        6481,
        7431,
        7432,
        7605,
        7784,
        7785,
        7882,
        7889,
        7890,
        7891
    ],
    "-atshe": [
        492
    ],
    "-atye”": [
        492
    ],
    "-ca": [
        2470
    ],
    "-gbe": [
        7265
    ],
    "-tepowin": [
        7412
    ]
};
